import { RouterModule, Routes } from "@angular/router";
import { GuardService } from "../app/shared/services/guard/guard.service";
import { NgModule } from "@angular/core";

const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
    },
    {
        path: 'home',
        loadChildren: () => import('app_dashboard/pages/home/dashboard-home.module').then(m => m.DashboardHomeModule),
        canActivate: [GuardService],
    },
    {
        path: ':id',
        loadChildren: () => import('app_dashboard/pages/dashboard/dashboard-page.module').then(m => m.DashboardPageModule),
        canActivate: [GuardService],
    },
    {
        path: '**',
        redirectTo: '/home',
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
    ],
    exports: [
        RouterModule,
    ]
})
export class DashboardRoutingModule {}
